<template>
    <div class="payment-modal-content -first">
        <transition-group name="list">
            <div
                class="payments-form-block"
                :class="{ '-active': index <= currentQuestion }"
                v-for="(question, index) in examQuestions"
                :key="index"
            >
                <div
                    class="payments-form-question"
                    :class="{ '-active': true }"
                >
                    {{ question.question }}
                </div>
                <div class="payments-form-answers">
                    <div
                        @click="answerQuestion(index, answer)"
                        :key="answer.key"
                        v-for="answer in question.answers"
                        class="payments-form-answer"
                        :class="answerClass(index, answer)"
                    >
                        <transition name="fade">
                            <div
                                class="form-question-active"
                                v-if="isCorrect(index, answer)"
                            >
                                <i class="material-icons">check</i>
                            </div>
                            <div
                                class="form-question-active -incorrect"
                                v-if="isIncorrect(index, answer)"
                            >
                                <i class="material-icons">close</i>
                            </div>
                        </transition>
                        <div>
                            <div class="template-title">
                                {{ answer.value }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
        <div class="exam-actions" v-if="currentQuestion == webinar.exam.length">
            <div>
                <div v-if="showResults">
                    <h2 v-if="!isExamPassed">Niestety nie udało się</h2>
                    <h2 v-if="isExamPassed">Gratulacje! Udało się</h2>
                    <p>Minimalny wynik to 50%</p>
                    <p>{{ `Twój wynik to: ${percentValue}%` }}</p>
                </div>
            </div>
            <ActionButton
                v-if="!showResults"
                @click="checkAnswers"
                color="apple"
                :loading="loading"
                :label="'Sprawdź'"
            />
            <ActionButton
                v-if="!isExamPassed && showResults"
                @click="resetExam"
                color="apple"
                :label="'Spróbuj ponownie'"
            />
            <ActionButton
                v-if="isExamPassed && showResults"
                @click="$emit('examPassed')"
                color="apple"
                :label="confirmationLabel"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        webinar: Object,
        type: {
            type: String,
            default: 'webinar'
        }
    },
    data() {
        return {
            currentQuestion: 0,
            loading: false,
            showResults: false,
            isExamPassed: false,
            percentValue: 0,
            answers: {}
        }
    },
    computed: {
        confirmationLabel() {
            return this.type == 'course'
                ? 'Wróć do modułów'
                : 'Przejdź do certyfikatu'
        },
        examQuestions() {
            return this.webinar.exam.filter(
                (question, index) => index <= this.currentQuestion
            )
        }
    },
    methods: {
        resetExam() {
            this.answers = {}
            this.currentQuestion = 0
            this.showResults = false
        },
        answerClass(questionIndex, answer) {
            const question = this.webinar.exam[questionIndex]
            const selectedAnswer = this.answers[questionIndex]
            const classes = []
            if (answer.key == selectedAnswer) {
                classes.push('-selected')
            }
            if (
                (answer.key == question.correct ||
                    (selectedAnswer == question.correct &&
                        answer.key == selectedAnswer)) &&
                this.showResults
            ) {
                classes.push('-correct')
            }
            if (
                answer.key == selectedAnswer &&
                selectedAnswer != question.correct &&
                this.showResults
            ) {
                classes.push('-incorrect')
            }
            return classes
        },
        async checkAnswers() {
            if (this.loading) {
                return
            }
            this.loading = true
            try {
                let data = await this.getExamStorage()
                this.isExamPassed = this.checkIfPassed()
                const dataKey = this.getDataKey()
                data[dataKey] = this.isExamPassed
                await this.saveAnswersToStorage(data)
                await this.$apiService.getStorage()
                this.showResults = true
                this.loading = false
                this.$emit('scroll')
            } catch (error) {
                this.$Network.handleError(error)
                this.loading = false
            }
        },
        getExamStorage() {
            return this.$api
                .get(`v1/storage/finishedExams`)
                .then(({ data }) => {
                    return data ? data : {}
                })
        },
        saveAnswersToStorage(data) {
            return this.$api.put(`v1/storage/finishedExams`, {
                value: data
            })
        },
        getDataKey() {
            const uuid = this.$route.params.uuid
            return this.type == 'course' ? `${uuid}-${this.webinar.id}` : uuid
        },
        checkIfPassed() {
            const correctAnswers = this.webinar.exam.filter(
                (question, index) => {
                    const answer = this.answers[index]
                    return answer == question.correct
                }
            ).length
            this.percentValue = Math.floor(
                Math.round((correctAnswers / this.webinar.exam.length) * 100)
            )
            return this.percentValue >= 50
        },
        isIncorrect(questionIndex, answer) {
            if (!this.showResults) {
                return false
            }
            const question = this.webinar.exam[questionIndex]
            return (
                question.correct != answer.key &&
                answer.key == this.answers[questionIndex]
            )
        },
        isCorrect(questionIndex, answer) {
            if (!this.showResults) {
                return false
            }
            const question = this.webinar.exam[questionIndex]
            return question.correct == answer.key
        },
        answerQuestion(questionIndex, answer) {
            if (this.showResults) {
                return
            }
            this.answers[questionIndex] = answer.key
            if (questionIndex == this.currentQuestion) {
                this.currentQuestion += 1
            }
            this.$forceUpdate()
            this.$emit('scroll')
        }
    }
}
</script>
<style lang="scss" scoped>
.payments-form-answer {
    color: var(--color) !important;

    &.-selected {
        border-color: $accent-apple;
        font-family: $input-family;
        background: transparent;
    }
    &.-correct {
        background: $accent-apple;
    }
    &.-incorrect {
        background: $accent-red;
        border-color: $accent-red;
    }
}
.form-question-active {
    &.-incorrect {
        background: $accent-red;
    }
}
.exam-actions {
    border-top: 0.2rem solid $accent-apple;
    padding-top: 1rem;
    margin-right: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
h2 {
    margin: 0;
}
p {
    margin: 0;
    margin-top: 0.5rem;
}
.payment-modal-content {
    &.-first {
        &::after {
            background: #303030;
        }
    }
}
</style>
